import { Box, Stack, Typography, useTheme } from "@mui/material";
import i18next, { t } from "i18next";

import { formatNumber } from "src/utils/formatting";

type GoalSectionProps = {
    score: number;
    year: number;
    unitLabel: string;
    precision: number;
};

export const GoalSection = (props: GoalSectionProps) => {
    const { score, year, unitLabel, precision } = props;
    const theme = useTheme();

    return (
        <Stack
            spacing={theme.spacing(5.5)}
            alignItems="center"
            justifyContent="start"
            p={theme.spacing(4)}
            sx={{
                height: "100%",
                mb: theme.spacing(4),
            }}
        >
            <Stack
                direction="column"
                spacing={theme.spacing(1)}
                alignItems="center"
                justifyContent="center"
                mb={theme.spacing(10)}
            >
                <Typography variant="h2" align="center">
                    {t("puck.widgets.actionPlan.goal.title")}
                </Typography>
                <Typography
                    variant="body2"
                    fontWeight={theme.typography.fontWeightMedium}
                    fontSize={theme.typography.h3.fontSize}
                    align="center"
                >
                    {year}
                </Typography>
            </Stack>
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flexDirection: "column",
                    width: "100%",
                    maxWidth: "300px",
                    aspectRatio: "1 / 1",
                    borderRadius: "100%",
                    backgroundColor: `${theme.palette.primary.main}25`,
                }}
            >
                <Typography variant="h1" align="center">
                    {formatNumber(score, i18next.language, { maximumFractionDigits: precision })}
                </Typography>
                <Typography
                    variant="body2"
                    color="text.secondary"
                    align="center"
                    sx={{ color: theme.custom.grey[1900] }}
                >
                    {unitLabel}
                </Typography>
            </Box>
        </Stack>
    );
};

export default GoalSection;
